import React from 'react';
import styles from './TitleSection.module.css';

function TitleSection() {
  return (
    <div className={styles.titleSection}>
      <img 
        src="https://ihcmlcnktfrrojtkrtbt.supabase.co/storage/v1/object/public/asset/common/walter.svg"
        alt="WALTER"
        className={styles.logo}
      />
      <div className={styles.newtonsCradle}>
        <div className={styles.newtonsBall}></div>
        <div className={styles.newtonsBall}></div>
        <div className={styles.newtonsBall}></div>
        <div className={styles.newtonsBall}></div>
        <div className={styles.newtonsBall}></div>
      </div>
    </div>
  );
}

export default TitleSection; 